__turbopack_context__.v({
  "splide-loading": "GalleryCarousel-module-scss-module__L_Eofa__splide-loading",
  "splide_slidewrap": "GalleryCarousel-module-scss-module__L_Eofa__splide_slidewrap",
});
